import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LoginPage from "./Login"; 
import SignUpPage from "./SignUp";
import ResetPasswordPage from "./ResetPassword";
import TwoFactorAuthPage from "./TwoFactorAuth";
import NodeStatusPage from "./NodeStatus";
import AnomalyStatusPage from "./AnomalyStatus";
import ApplicationManagementPage from "./ApplicationManagement";
import ApplicationUsersPage from "./UserList";
import TransactionHistoryPage from "./TransactionHistory";
import UserTransactionHistoryPage from "./UserTransactionHistory";
import Layout from "@/components/layout";


const isAuthenticated = () => {
  const token = localStorage.getItem("auth_token");
  return !!token;
};


const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  const [authChecked, setAuthChecked] = useState(false);

  
  useEffect(() => {
    setAuthChecked(true);
  }, []);

  
  if (!authChecked) {
    return null;
  }

  return (
    <Router>
      <Routes>
        {/* Herkese açık sayfalar */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/resetpassword" element={<ResetPasswordPage />} />
        <Route path="/twofactorauth" element={<TwoFactorAuthPage />} />

        {/* Korumalı sayfalar */}

        <Route
          path="/nodestatus"
          element={
            <ProtectedRoute>
              <Layout>
                <NodeStatusPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/anomalystatus"
          element={
            <ProtectedRoute>
              <Layout>
                <AnomalyStatusPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/applicationmanagement"
          element={
            <ProtectedRoute>
              <Layout>
                <ApplicationManagementPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/applicationmanagement/:appId/users"
          element={
            <ProtectedRoute>
              <Layout>
                <ApplicationUsersPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactionhistory"
          element={
            <ProtectedRoute>
              <Layout>
                <TransactionHistoryPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/applicationmanagement/:appId/users/:userId/transactionhistory"
          element={
            <ProtectedRoute>
              <Layout>
                <UserTransactionHistoryPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/applicationmanagement" />} />
      </Routes>
    </Router>
  );
}

export default App;
